@if (appSettingsService.brandSig()) {
  <div
    appBootstrapInit
    [attr.data-brand]="appSettingsService.brandSig() | lowercase"
    class="d-flex flex-column min-vh-100 w-100"
  >
    <app-header />
    <main class="main d-flex flex-column flex-grow-1 flex-shrink-0">
      <router-outlet></router-outlet>
    </main>
    <app-footer />
    @if (showContactFab) {
      <app-contact-fab></app-contact-fab>
    }
    <app-popup-modal-shell />
  </div>
}
